@if(!isChangePassword()){
<div class="page-title-block bg-transparent common-head">
    <div class="title-block-left flex-row align-items-center">
        <h1 class="title h3">My Account</h1>
    </div>
</div>
<div class="content-block-main gap-32 flex-1 setting-tab">
    <mat-tab-group #tabGroup [(selectedIndex)]="selectedTabIndex">
        <mat-tab label="Profile">
            <div class="tab-content-scrollable">
                <div class="profile-content border-bottom pb-4" appSpin [spinnerConfig]='spinnerConfig()'>
                    <h4 class="title text-gray-5">Profile Picture</h4>
                    @if(!isProfilePicAvailable()){
                    <ngx-avatars initialsSize="2" size="100" [name]="avatarText()" fgColor="rgba(0, 0, 0, 0.8)"
                      [bgColor]="selectedColor()"></ngx-avatars>
                    <span class="d-flex gap-12">
                        <input type="file" (change)="fileChangeEventProfile($event, profileImageInput)" hidden
                            #profileImageInput accept="image/jpeg,image/jpg,image/png,image/webp,image/gif">
                        <button mat-button mat-flat-button (click)="profileImageInput.click()" color="primary"
                            class="button-normal">Upload Image</button>
                        <button mat-button mat-flat-button (click)="openColorDialog()" color="secondary"
                            class="button-normal">Change Color</button>
                    </span>


                    } @else {
                    <span class="d-flex gap-12 flex-column">
                        <span>
                            <img [src]="profilePic()" alt="profile pic" class="headerImage" />
                        </span>
                        <span class="d-flex gap-12">
                            <button mat-button mat-flat-button color="primary" class="button-normal"
                                (click)="removeImageDialogue('PROFILE_PICTURE')">
                                Remove Image
                            </button>
                            <button mat-button mat-flat-button color="secondary" class="button-normal disabled">
                                Change Color
                            </button>
                        </span>

                    </span>

                    }
                </div>
                <div class="profile-form py-4">
                    <h4 class="title text-gray-5 pb-3">Personal Information</h4>
                    <div class="editable-detail-form">
                        <form [formGroup]="editUserForm" class="form-group row-items-2" autocomplete="off"
                            (ngSubmit)="updateProfile()">
                            <mat-form-field class="form-item fixed-label w-100" floatLabel="always">
                                <mat-label>Member ID</mat-label>
                                <input matInput placeholder="Member ID" formControlName="memberID"
                                    (input)="alphaNumeric($event)" (blur)="validateMemberId()" maxlength="100" />
                            </mat-form-field>

                            <mat-form-field class="form-item fixed-label" floatLabel="always" autocomplete="off">
                                <mat-label>First Name</mat-label>
                                <input matInput type="text" autocomplete="off" placeholder="First Name"
                                    (input)="onlyChars($event,'userfn')" formControlName="firstName" maxlength="100"
                                    required />
                            </mat-form-field>

                            <mat-form-field class="form-item fixed-label" floatLabel="always">
                                <mat-label>Last Name</mat-label>
                                <input matInput placeholder="Last Name" (input)="onlyChars($event,'userln')"
                                    formControlName="lastName" maxlength="100" required />
                            </mat-form-field>

                            <mat-form-field class="form-item fixed-label" floatLabel="always">
                                <mat-label>Email</mat-label>
                                <input matInput placeholder="Email" formControlName="userEmail"
                                    [value]="userEmail.value | lowercase" maxlength="100" appDisableAutofill required>
                                <mat-error *ngIf="!userEmail.valid">
                                    <span *ngIf="userEmail.errors?.uniqueEmail"></span>
                                </mat-error>
                            </mat-form-field>

                            <mat-form-field class="form-item fixed-label" floatLabel="always">
                                <mat-label>Title</mat-label>
                                <input matInput placeholder="Title" formControlName="title" maxlength="80" />
                            </mat-form-field>
                            <mat-form-field class="form-item fixed-label" floatLabel="always">
                                <mat-label>Business Phone</mat-label>
                                <input matInput placeholder="Business Phone" formControlName="businessPhone"
                                    (input)="handlePhone($event,'business')" minlength="14" maxlength="14"
                                    appDisableAutofill />
                            </mat-form-field>

                            <mat-form-field class="form-item fixed-label" floatLabel="always">
                                <mat-label>Cell Phone</mat-label>
                                <input matInput placeholder="Cell Phone" formControlName="cellPhone" minlength="14"
                                    maxlength="14" appDisableAutofill (input)="handlePhone($event,'cell')" />
                            </mat-form-field>


                            <mat-form-field class="form-item fixed-label" floatLabel="always">
                                <mat-label>Hourly Rate</mat-label>
                                <input matInput placeholder="-" formControlName="hourlyrate" type="number" 
                                    (input)="checkForDecimal($event)" maxlength="17" />
                            </mat-form-field>


                            <mat-form-field class="form-item fixed-label" floatLabel="always">
                                <mat-label>License Number</mat-label>
                                <input matInput placeholder="" formControlName="licenseNumber" maxlength="11" />
                            </mat-form-field>

                            <span>
                                <button mat-button mat-flat-button color="primary" class="button-normal" type="submit"
                                    (click)="updateProfile()" [disabled]="!editUserForm.valid || isProfileNoChanges()">Save Changes</button>
                            </span>
                        </form>
                      
                    </div>
                </div>
                  <div class="change-pass-btn pt-4 pb-2 border-top ">
                            <button mat-button mat-flat-button color="primary" class="button-normal"
                             (click)="isChangePassword.set(true);$event.stopPropagation();">Change Password</button>
                    </div>

            </div>

        </mat-tab>
        <mat-tab label="Firm Info">
            <div class="tab-content-scrollable">
                <div class="profile-content border-bottom pb-4" appSpin [spinnerConfig]='spinnerConfig()'>
                    <h4 class="title text-gray-5">Firm Logo</h4>

                    @if(!isFirmLogoAvailable()){
                    <span class="d-flex flex-column gap-20">
                        <span>
                             <img src="../../../../assets/images/ui-uplift-icons/global/firm-dummy-logo.svg" alt="">
                        </span>
                        <input type="file" (change)="fileChangeEventFirm($event, firmLogoInput)" hidden #firmLogoInput accept="image/jpeg,image/jpg,image/png,image/webp,image/gif">
                        <div>
                             <button mat-button mat-flat-button (click)="firmLogoInput.click()" color="primary"
                            class="button-normal" [disabled]="!acl.hasFirmInformationEdit">Upload Logo</button>
                        </div>
                       
                    </span>

                    } @else {
                    <span class="d-flex flex-column gap-12">
                        <span>
                            <img [src]="firmLogo()" alt="Firm Logo" class="headerImage" />

                        </span>
                        <span>
                            <button mat-button mat-flat-button color="secondary" class="button-normal"
                                (click)="removeImageDialogue('FIRM_LOGO')">
                                Remove Logo
                            </button>
                        </span>

                    </span>

                    }
                </div>

                <div class="profile-form pt-4">
                    <h4 class="title text-gray-5 pb-3">Firm Information</h4>

                    <app-firm-information></app-firm-information>

                </div>

            </div>
        </mat-tab>
        <mat-tab label="Time Zone">
            <div class="card" id="timeZone" appSpin [spinnerConfig]='spinnerConfigTimeZone()'>
                <div class="card-body flex-column justify-content-between flex-wrap gap-20 timezone-content">
                    <div class="flexbox-column gap-4">
                        <p class="">Set your local time zone for accurate and consistent transaction records
                            and
                            financial reports.</p>
                    </div>
                    <div class="flexbox-row align-items-end flex-wrap timezone-dropdown">
                        <div class="ng-form-field select-input timezone-dropdown-inner w-100">
                            <form class="timeZoneSelectedWidth">
                                <ng-select [items]="listOfTimeZones" [formControl]="selectedTimeZone" [clearable]="false"
                                    bindLabel="zoneNameUi" bindValue="uniqueId" (click)="$event.stopPropagation()">
                                    <ng-template ng-label-tmp let-item="item">
                                        <i class="fa-regular fa-clock text-gray-6 fs-18"></i>
                                        {{ item.zoneNameUi }}
                                    </ng-template>
                                </ng-select>
                            </form>
                        </div>



                    </div>

                    <!-- <div class="d-flex flex-column gap-12">
                        <h4 class="title text-gray-6">Time format</h4>
                        <p>Choose 12-hour or 24-hour time format to match your regional or firm preference. Applied
                            across all reports, logs, and activity records.</p>
                        <mat-radio-group class="horizontal-items pt-4 pb-5" aria-label="Select an option">
                            <mat-radio-button>12 Hours</mat-radio-button>
                            <mat-radio-button>24 Hours</mat-radio-button>
                        </mat-radio-group>
                    </div> -->

                    <span>
                        <button mat-button mat-flat-button color="primary" class="button-medium" type="submit"
                            (click)="confirmSelectedTimeZone()"
                            [disabled]="selectedTimeZone.value === defaultValue || !selectedTimeZone.valid">
                            Save Changes
                        </button>
                    </span>


                </div>
            </div>
        </mat-tab>

    </mat-tab-group>
</div>
} @else {
    <app-change-password (closePasswordPage)="isChangePassword.set(false)"></app-change-password>
}

<ng-template #updateTimeZoneTemplate>
    <div class="countable-dialog" (click)="$event.stopPropagation()" style="width: 350px;">
        <div mat-dialog-title class="dialog-header d-flex flex-column align-items-center p-0">
            <span class="badge badge-warning badge-circle icon-bordered-warning text-center">
                <i class="fa-regular fa-alarm-clock"></i>
            </span>
            <h4 class="title text-center">Update Standard Time Zone</h4>
            <button color="error" class="close" [mat-dialog-close]="false">
                <i class="fa-regular fa-xmark clear-icon"></i>
            </button>
        </div>

        <div mat-dialog-content class="content dialog-body-content text-center gap-20 mt-2 mb-32">
            <p class="fw-medium">Note: This will impact and update all the current transaction records and financial
                reports</p>
            <p class="text-gray-6">Are you sure you want to update the time zone?</p>
        </div>

        <div mat-dialog-actions class="dialog-footer button-group w-100">
            <button mat-button mat-stroked-button class="button-normal flex-1" color="dark"
                [mat-dialog-close]="false">Cancel</button>
            <button mat-button mat-flat-button class="button-normal flex-1 m-0" color="primary"
                [mat-dialog-close]="true">Confirm</button>
        </div>
    </div>
</ng-template>


<ng-template #userAcknowledgementDialog>
    <div class="countable-dialog confirmation-dailog" (click)="$event.stopPropagation()">
        <div mat-dialog-title class="dialog-header d-flex flex-column align-items-center p-0">
            <span class="badge badge-warning badge-circle icon-bordered-warning">
                <i class="fa-regular fa-triangle-exclamation text-warning"></i>
            </span>
            <h4 class="title text-center">Email Change Confirmed</h4>
            <button color="error" class="close" [mat-dialog-close]="true">
                <i class="fa-regular fa-xmark clear-icon"></i>
            </button>
        </div>

        <div mat-dialog-content class="content dialog-body-content text-center gap-8 mt-2 mb-32">
            <p>We've sent a confirmation email to your previous address.</p>
            <p>A verification link has been sent to your new email to verify your password.</p>
        </div>

        <div mat-dialog-actions class="dialog-footer button-group" (click)="$event.stopPropagation()">
            <button mat-button mat-flat-button class="button-normal" color="primary"
                [mat-dialog-close]="true">OK</button>
        </div>
    </div>
</ng-template>


<ng-template #nameChangeRestrictionDialog>
    <div class="countable-dialog confirmation-dailog" (click)="$event.stopPropagation()">
        <div mat-dialog-title class="dialog-header d-flex flex-column align-items-center p-0">
            <span class="badge badge-warning badge-circle icon-bordered-warning">
                <i class="fa-regular fa-triangle-exclamation text-warning"></i>
            </span>
            <h4 class="title text-center">Name Modification Restricted</h4>
            <button color="error" class="close" [mat-dialog-close]="true">
                <i class="fa-regular fa-xmark clear-icon"></i>
            </button>
        </div>

        <div mat-dialog-content class="content dialog-body-content text-center gap-8 mt-2 mb-32">
            <p>Name changes is not allowed as its directly linked to all key records.</p>
            <p>Please delete the user instead and create a new user.</p>
        </div>

        <div mat-dialog-actions class="dialog-footer button-group" (click)="$event.stopPropagation()">
            <button mat-button mat-flat-button class="button-normal" color="primary"
                [mat-dialog-close]="true">OK</button>
        </div>
    </div>
</ng-template>





<ng-template #removeProfileImageTemplate>
    <div class="countable-dialog confirmation-dailog" (click)="$event.stopPropagation()">
        <div mat-dialog-title class="dialog-header d-flex flex-column align-items-center p-0">
            <span class="badge badge-error badge-circle icon-bordered-error">
                <i class="fa-regular fa-image text-error"></i>
            </span>
            <h4 class="title text-center">Remove Profile Image</h4>
            <button color="error" class="close" [mat-dialog-close]="false">
                <i class="fa-regular fa-xmark clear-icon"></i>
            </button>
        </div>

        <div mat-dialog-content class="content dialog-body-content text-center gap-8 mt-2 mb-32">
            <p>Are you sure you want to remove the profile image?</p>
        </div>

        <div mat-dialog-actions class="dialog-footer button-group" (click)="$event.stopPropagation()">
            <button mat-button mat-stroked-button class="button-normal" color="dark"
                [mat-dialog-close]="false">Cancel</button>
            <button mat-button mat-flat-button class="button-normal" color="error"
                [mat-dialog-close]="true">Remove</button>
        </div>
    </div>
</ng-template>

<ng-template #removeFirmLogoTemplate>
    <div class="countable-dialog confirmation-dailog" (click)="$event.stopPropagation()">
        <div mat-dialog-title class="dialog-header d-flex flex-column align-items-center p-0">
            <span class="badge badge-error badge-circle icon-bordered-error">
                <i class="fa-regular fa-image text-error"></i>
            </span>
            <h4 class="title text-center">Remove Firm Logo?</h4>
            <button color="error" class="close" [mat-dialog-close]="false">
                <i class="fa-regular fa-xmark clear-icon"></i>
            </button>
        </div>

        <div mat-dialog-content class="content dialog-body-content text-center gap-20 px-5">
            <p>This will replace your firm logo with a default placeholder across the platform.</p>
            <p>You can upload a new logo at any time.</p>
        </div>

        <div mat-dialog-actions class="dialog-footer button-group" (click)="$event.stopPropagation()">
            <button mat-button mat-stroked-button color="dark"
                [mat-dialog-close]="false">Cancel</button>
            <button mat-button mat-flat-button color="error"
                [mat-dialog-close]="true">Remove</button>
        </div>
    </div>
</ng-template>